<template>
  <div class="container">
    <div class="container_form">
      <el-form :inline="true" :model="formObj" style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        " size="small" ref="formObjRefs">
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select filterable style="width: 100%" v-model="formObj.settlementBatchName" placeholder="请选择结算批次名称">
            <el-option v-for="(item, index) in queryFormSettlementList" :key="index" :label="item"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算师傅名称" prop="installerIds">
          <el-select multiple style="width: 100%" filterable v-model="formObj.installerIds" placeholder="请选择结算师傅名称">
            <el-option v-for="item in queryAllUserList" :key="item.id" :label="item.userName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyIds">
          <el-select multiple style="width: 100%" filterable v-model="formObj.companyIds" placeholder="请选择公司名称">
            <el-option v-for="item in companyList" :key="item.companyId" :label="item.companyManager"
              :value="item.companyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getPageData(true)">查询</el-button>
          <el-button type="info" size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="container_table">
        <!-- 金额统计 -->
         <AmountStatistics  v-bind="amountStatistics"/>
        <div class="table_btn">
          <el-button type="danger" size="mini" @click="newSettlement" v-show="authorization('/home-admin/settlementManage/add-settlement')
            ">新建结算单</el-button>
        </div>
        <BaseTable :tableData="tableData" :columns="columns" :showPagination="true" :showOperationColumn="true"
          :operationColumnWidth="150" :total="total" @size-change="onSizeChange" @current-change="onCurrentChange">
          <template #settlementBatchName="{ row }">
            <span class="batch-name-link" @click="jumpToReport(row.settlementBatchName)">{{ row.settlementBatchName }}</span>
          </template>
          <template #totalAmount="{ row }" v-if="status === 3">
            <span v-if="row.totalAmount === null || row.totalAmount === '' || row.totalAmount === undefined" style="color: #ffc107;">
              请再次结算
            </span>
            <span v-else>{{ row.totalAmount }}</span>
          </template>
          <template #operation="{ row }">
            <el-tooltip effect="dark" content="查看" placement="top-end">
              <el-button type="primary" icon="el-icon-view" size="mini" @click="edit(row, true)" circle></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="修改" placement="top-end">
              <el-button type="warning" icon="el-icon-edit" size="mini" @click="handleEditClick(row)" style="margin: 0 5px"
                circle></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="操作记录" placement="top-end">
              <el-button type="info" icon="el-icon-s-operation" size="mini" @click="operationRecord(row)"
                style="margin-right:5px;margin-left: 0px;" circle></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top-end">
              <el-popconfirm title="确认删除吗？" @confirm="deleteData(row)">
                <el-button content="删除" slot="reference" type="danger" icon="el-icon-delete" circle
                  size="mini"></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </BaseTable>
      </div>
    </div>
    <!-- 新建结算单 -->
    <el-dialog title="选择结算批次信息" :visible.sync="selectSettlement" width="600px" :close-on-click-modal="false">
      <el-form :model="form" label-width="140px" :rules="rules" ref="settlementForm" size="small"
        style="padding-right: 20px; padding-top: 40px">
        <el-form-item label="结算批次" prop="settlementBatchName">
          <el-select filterable style="width: 100%" v-model="form.settlementBatchName" placeholder="请选择结算批次"
            allow-create default-first-option @change="selectName">
            <el-option v-for="(item, index) in settlementList" :key="index" :label="item.settlementBatchName"
              :value="item.settlementBatchName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算师傅" prop="responsibleUserId">
          <el-select filterable style="width: 100%" v-model="form.responsibleUserId" placeholder="请选择结算师傅"
            @change="selectUser">
            <el-option v-for="item in allUserList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitSettlementName">确 认</el-button>
        <el-button size="small" @click="selectSettlementClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="operateType"
      :visible.sync="dialogNewSettlement"
      fullscreen
      custom-class="settlement-fullscreen-dialog"
      :close-on-click-modal="false"
      :before-close="cancel">
      <newSettlement ref="newSettlementRefs" :addForm="addForm" :success="success" @closeDialog="closeDialog">
      </newSettlement>
      <span slot="footer" class="dialog-footer" v-show="!addForm.isSee">
        <el-button 
          type="success" 
          size="small" 
          @click="submitSettlement(3)"
          :disabled="!isCommissionDataLoaded"
          :loading="!isCommissionDataLoaded">
          保存为预结算
        </el-button>
        <el-button 
          type="primary" 
          size="small" 
          @click="submitSettlement(null)"
          :disabled="!isCommissionDataLoaded"
          :loading="!isCommissionDataLoaded">
          提 交
        </el-button>
        <el-button size="small" @click="cancel">取 消</el-button>
      </span>
    </el-dialog>
    <Record ref="recordRefs" />
    <!-- 确认修改组件 -->
    <ConfirmEdit 
      ref="confirmEditRefs" 
      @confirm-edit="handleConfirmEdit"
    />
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import { authorization } from "../../../authorization/authorization";
import newSettlement from "./components/newSettlement.vue";
import ConfirmEdit from "@/views/settlement-model/components/ConfirmEdit.vue";
import  AmountStatistics from "@/views/settlement-model/components/AmountStatistics.vue";
import Record from "@/components/Record";
export default {
  name: "TobeConfirmed",
  components: {
    BaseTable,
    newSettlement,
    ConfirmEdit,
    Record,
    AmountStatistics
  },
  props: {
    // 草稿或待确认
    status: {
      type: Number,
      default: null,
    },
    // 路由查询参数
    routeQuery: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      operateType: "新建结算单",
      formObj: {
        settlementBatchName: '',
        installerIds: [],
        companyIds: [],
      },
      page: {
        size: 10,
        current: 1
      },
      total: 0,
      tableData: [],
      amountStatistics: {
        totalAmount: 0,
        paidAmount: 0,
        remainingAmount: 0
      },
      columns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          width: 100,
          slot: "settlementBatchName",
        },
        {
          prop: "totalAmount",
          label: "总金额",
          slot: this.status === 3 ? "totalAmount" : null,
        },
        {
          prop: "responsibleUserIdStr",
          label: "结算师傅名称",
        },
        {
          prop: "companyIdStr",
          label: "公司名称",
        },
        {
          prop: "createTime",
          label: "创建时间",
        },
        {
          prop: "createdByStr",
          label: "创建人",
        },
        {
          prop: "updateTime",
          label: "修改时间",
        },
        {
          prop: "updatedByStr",
          label: "修改人",
        },
      ],
      form: {
        settlementBatchName: "",
        responsibleUserId: ''
      },
      rules: {
        settlementBatchName: [
          { required: true, message: "请选择结算批次", trigger: "change" },
        ],
        responsibleUserId: [
          { required: true, message: "请选择结算师傅", trigger: "change" },
        ],
      },
      selectSettlement: false,
      dialogNewSettlement: false,
      settlementList: [],
      queryFormSettlementList: [],
      allUserList: [],
      addForm: {},
      companyList: this.$store.state.company || [],
      success: false,
      queryAllUserList: this.$store.state.allUserList || [],
    };
  },
  created() {
    this.querySettlementList();
    this.getSettlementList();
    this.loadAllUserList();
    // 处理从报表页面跳转过来的查询参数
    this.handleRouteQuery();
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      if (to.path !== from.path) {
        this.handleRouteQuery();
      }
    },
    // 监听prop变化
    routeQuery: {
      handler() {
        this.handleRouteQuery();
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    // 判断增项提成数据是否加载完成
    isCommissionDataLoaded() {
      return this.$refs.newSettlementRefs ? this.$refs.newSettlementRefs.isCommissionDataLoaded : true;
    }
  },
  methods: {
    authorization,
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.queryAllUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    operationRecord(row) {
      this.$refs.recordRefs.open(row)
    },
    newSettlement() {
      this.selectSettlement = true;
      this.operateType = '新建结算单'
    },
    onSizeChange(val) {
      this.page.size = val
      this.getPageData(false)
    },
    onCurrentChange(val) {
      this.page.current = val
      this.getPageData(false)
    },
    getPageData(flag) {
      if (flag) {
        this.page = {
          size: 10,
          current: 1
        }
      }
      const data = {
        page: this.page.current,
        size: this.page.size,
        queryInfoParams: {
          status: this.status || 0,
          ...this.formObj
        }
      }
      // 草稿或待确认
      const url = this.status === 3 ? '/v1/web/settlement-manage/settlement-order/listDraft' : '/v1/web/settlement-manage/settlement-order/listConfirmation'
      this.axios({
        url,
        method: 'post',
        data
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
          this.amountStatistics=res.data.data.extend;
          this.$store.dispatch('setPaymentCount');
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    submitSettlementName() {
      this.$refs.settlementForm.validate((valid) => {
        if (valid) {
          // 先校验批次是否同步完成
          if (this.form.settlementBatchName) {
            this.axios({
              url: "/pending-settlement-order/validate-batch-sync",
              method: "GET",
              params: {
                settlementBatchName: this.form.settlementBatchName,
              },
            }).then((res) => {
              if (res.data.code == 200) {
                // 校验通过，继续后续流程
                this.axios({
                  url: "/v1/web/settlement-manage/settlement-order/get",
                  method: "GET",
                  params: {
                    ...this.form,
                  },
                }).then((res) => {
                  if (res.data.code == 200) {
                    this.success = true
                    this.dialogNewSettlement = true
                    this.selectSettlementClose()
                  } else {
                    this.success = false
                    this.$message({
                      message: res.data.message,
                      type: 'error',
                      duration: 6000, // 设置为 0 表示不会自动关闭
                      showClose: true // 显示手动关闭按钮
                    })
                  }
                });
                this.addForm = {}
                let objForm = JSON.stringify(this.form);
                this.addForm = JSON.parse(objForm);
              } else {
                // 校验失败，显示错误信息
                this.$message({
                  message: res.data.message || '批次同步校验失败',
                  type: 'error',
                  duration: 6000,
                  showClose: true
                })
              }
            }).catch((err) => {
              this.$message({
                message: err.response?.data?.message || '批次同步校验失败',
                type: 'error',
                duration: 6000,
                showClose: true
              })
            });
          } else {
            // 如果没有批次名称，直接继续后续流程
            this.axios({
              url: "/v1/web/settlement-manage/settlement-order/get",
              method: "GET",
              params: {
                ...this.form,
              },
            }).then((res) => {
              if (res.data.code == 200) {
                this.success = true
                this.dialogNewSettlement = true
                this.selectSettlementClose()
              } else {
                this.success = false
                this.$message({
                  message: res.data.message,
                  type: 'error',
                  duration: 6000, // 设置为 0 表示不会自动关闭
                  showClose: true // 显示手动关闭按钮
                })
              }
            });
            this.addForm = {}
            let objForm = JSON.stringify(this.form);
            this.addForm = JSON.parse(objForm);
          }
        } else {
          return false;
        }
      });
    },
    selectSettlementClose() {
      this.$refs.settlementForm.resetFields();
      this.selectSettlement = false;
    },
    querySettlementList() {
      //结算批次下拉
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listPendingSettlementName",
      }).then((res) => {
        this.settlementList = res.data.data;
      });
    },
    getSettlementList() {
      this.axios({
        method: "post",
        url: `/pending-settlement-order/listSettlementName?status=${this.status||0}`,
      }).then((res) => {
        this.queryFormSettlementList = res.data.data;
      })
    },
    submitSettlement(status) {
      this.$confirm('是否要提交本次操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.addForm.id) {
          this.$refs.newSettlementRefs.editSubmit(status)
        } else {
          this.$refs.newSettlementRefs.submit(status)
        }
      }).catch((err) => {
        console.log(err)
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      })
    },
    selectName(val) {
      const data = this.settlementList.find(item => item.settlementBatchName === val)
      this.allUserList = data.userInfoList
      if (data.userInfoList.length === 1) {
        this.form.responsibleUserId = data.userInfoList[0].id
        this.form.userName = data.userInfoList[0].userName
      } else {
        this.form.responsibleUserId = ''
        this.form.userName = ''
      }
    },
    selectUser(val) {
      const data = this.allUserList.find(item => item.id === val)
      this.form.userName = data.userName
    },
    reset() {
      this.$refs.formObjRefs.resetFields();
      this.getPageData(true)
    },
   async edit(row, type) {
      if (type) {
        this.operateType = '查看结算单'
      } else {
        this.operateType = '编辑结算单'
        // 先校验批次是否同步完成
        const res = await this.axios({
          url: "/pending-settlement-order/validate-batch-sync",
          method: "GET",
          params: {
            settlementBatchName: row.settlementBatchName,
          }
        })

      if (res.data.code !== 200) {
        this.$message.error(res.data.message)
        return
      }
    }
    
      this.success = true
      this.addForm = {
        settlementBatchName: row.settlementBatchName,
        responsibleUserId: row.responsibleUserId,
        id: row.id,
        status: row.status,
        isSee: type,
      }
      this.dialogNewSettlement = true
    },
    
    // 处理修改按钮点击
    handleEditClick(row) {
      // 检查状态，如果 status = 0（待师傅确认），显示确认弹窗
      if (row.status === 0) {
        this.$refs.confirmEditRefs.open(row);
      } else {
        // 其他状态直接进入编辑模式
        this.edit(row, false);
      }
    },
    // 确认修改操作
    handleConfirmEdit(row) {
      // 刷新页面数据
      this.getPageData(false);
    },
    deleteData(row) {
      this.axios({
        method: 'DELETE',
        url: `/v1/web/settlement-manage/settlement-order/del/${row.id}`,
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('删除成功')
          this.getPageData(false)
          this.querySettlementList()
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    closeDialog(flag) {
      this.dialogNewSettlement = false
      this.getPageData(flag)
      this.querySettlementList()
    },
    cancel() {
      if (this.addForm.isSee) {
        this.dialogNewSettlement = false
      } else {
        this.$confirm('此操作会关闭当前页面且数据不会被保存,是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.newSettlementRefs.clearData()
          this.dialogNewSettlement = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭'
          });
        })
      }
    },
    jumpToReport(batchName) {
      // 跳转到结算报表页面并自动查询指定批次
      this.$router.push({
        path: '/home-admin/settlementManage/report',
        query: { 
          settlementBatchName: batchName,
          autoSearch: 'true'
        }
      });
    },
    handleRouteQuery() {
      // 处理从报表页面跳转过来的查询参数
      // 优先使用prop传递的routeQuery，如果没有则使用$route.query
      const query = Object.keys(this.routeQuery).length > 0 ? this.routeQuery : this.$route.query;
      console.log('tobe-confirmed handleRouteQuery:', query);
      
      if (query.settlementBatchName && query.autoSearch === 'true') {
        console.log('设置结算批次名称:', query.settlementBatchName);
        // 设置结算批次名称并自动查询
        this.formObj.settlementBatchName = query.settlementBatchName;
        // 等待数据加载完成后再查询
        this.$nextTick(() => {
          setTimeout(() => {
            console.log('执行自动查询');
            this.getPageData(true);
          }, 500); // 给一点时间让下拉选项加载完成
        });
      } else {
        console.log('正常加载数据');
        // 正常加载数据
        this.getPageData(true);
      }
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.table_btn {
  background-color: #fff;
  padding: 0px 0 10px 0px;
  border-radius: 8px 8px 0 0;
}

.container_table {
  height: 100%;
  padding: 20px 5px 20px 20px;
  background-color: #fff;
  border-radius: 8px;
}

::v-deep .el-dialog__body {
  padding-top: 0px;
}
.batch-name-link {
  color: #409EFF;
  cursor: pointer;
}
.batch-name-link:hover {
  text-decoration: underline;
}
</style>
